import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '../stores/auth'
import TelaLogin from '../views/TelaLogin.vue'
import MainDashboard from '../views/MainDashboard.vue'
import ValidacaoSucesso from '../views/ValidacaoSucesso.vue'
import ValidacaoFalhou from '../views/ValidacaoFalhou.vue'
import RecuperarSenha from '../views/RecuperarSenha.vue'
import RedefinirSenha from '../views/RedefinirSenha.vue'
import PedidoVendaAdministrar from '../components/Vendas/pedidoVenda/PedidoVendaAdministrar.vue'
import PedidoVendaCadastro from '../components/Vendas/pedidoVenda/PedidoVendaCadastro.vue'
import TipoImagemConfigAdministrar from '../components/configuracoes/tipoImagemConfig/TipoImagemConfigAdministrar.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: TelaLogin
  },
  {
    path: '/recuperar-senha',
    name: 'RecuperarSenha',
    component: RecuperarSenha
  },
  {
    path: '/redefinir-senha',
    name: 'RedefinirSenha',
    component: RedefinirSenha
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: MainDashboard,
    meta: { requiresAuth: true },
    children: [
      {
        path: 'vendas/pedido-venda/administrar',
        name: 'PedidoVendaAdministrar',
        component: PedidoVendaAdministrar,
        meta: { requiresAuth: true }
      },
      {
        path: 'vendas/pedido-venda/cadastro',
        name: 'PedidoVendaCadastro',
        component: PedidoVendaCadastro,
        meta: { requiresAuth: true }
      },
      {
        path: 'configuracoes/tipos-imagem',
        name: 'TipoImagemConfigAdministrar',
        component: TipoImagemConfigAdministrar,
        meta: { requiresAuth: true, modulo: 'CONFIGURACOES', permissao: 'ADMIN' }
      },
      {
        path: 'configuracoes/ia',
        name: 'IAConfiguracoes',
        component: () => import('../components/configuracoes/ia/IAConfiguracoes.vue'),
        meta: { requiresAuth: true, modulo: 'CONFIGURACOES', permissao: 'ADMIN' }
      }
    ]
  },
  {
    path: '/validacao-sucesso',
    name: 'ValidacaoSucesso',
    component: ValidacaoSucesso
  },
  {
    path: '/validacao-falhou',
    name: 'ValidacaoFalhou',
    component: ValidacaoFalhou
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// "Guarda de Navegação" - Protege as rotas
router.beforeEach((to, from, next) => {
  // 2. INSTANCIE A STORE DENTRO DA GUARDA
  const authStore = useAuthStore()
  // 3. USE O GETTER REATIVO DA STORE, NÃO O LOCALSTORAGE
  const { isAuthenticated } = authStore

  if (to.meta.requiresAuth && !isAuthenticated) {
    // CORREÇÃO: Quando redirecionamos para login por falta de auth,
    // não queremos que o router guarde a rota anterior para tentar voltar
    // pois isso causa erros de parâmetros perdidos após o novo login.
    next({ name: 'Login' })
  } else if (to.name === 'Login' && isAuthenticated) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
